import React from 'react';
import pcLogo from '../../../../assets/Images/pc-logo.png';
import './PolicyVerificationInvalidSection.css';

const PolicyVerificationInvalidSection: React.FC = () => {
  return (
    <div className="policy-invalid-container">
      {/* Header with Pacific Cross Logo */}
      <div className="policy-invalid-header">
        <img src={pcLogo} alt="Pacific Cross Logo" className="pc-logo" />
      </div>

      {/* Main Content */}
      <div className="policy-invalid-content">
        {/* Invalid Icon */}
        <div className="invalid-icon-container">
          <img 
            src="/travel-portal/public-assets/invalidqr-icon.svg" 
            alt="Invalid Policy" 
            className="invalid-icon"
          />
        </div>

        {/* Invalid Message */}
        <h1 className="invalid-title">This Policy is invalid.</h1>

        {/* Contact Information */}
        <div className="contact-info">
          <p className="contact-text">
            For assistance and inquiries, you may reach out to our Customer Services Team.
          </p>
          <div className="contact-details">
            <div className="contact-item">
              <img 
                src="/travel-portal/public-assets/phone-icon.svg" 
                alt="Phone" 
                className="contact-icon"
              />
              <span>+632 8230-8511</span>
            </div>
            <div className="contact-item">
              <img 
                src="/travel-portal/public-assets/email-icon.svg" 
                alt="Email" 
                className="contact-icon"
              />
              <span className='email-underline'>client_services@pacificcross.com.ph</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyVerificationInvalidSection;